define('fukit/behavior/show.modal.on.navigate.with.unsaved.changes.behavior',['require','exports','module','underscore','marionette','backbone','../model/base.model','./base.unsaved.changes.behavior','bluebird','../view/block/unsaved.changes.modal.view'],function(require, exports, module) {
  //prettier-ignore
  var _                          = require('underscore'),
      Mn                         = require('marionette'),
      Backbone                   = require('backbone'),
      BaseModel                  = require('../model/base.model'),
      BaseUnsavedChangesBehavior = require('./base.unsaved.changes.behavior'),
      Promise                    = require('bluebird'),
      UnsavedChangesModalView    = require('../view/block/unsaved.changes.modal.view');

  var ShowModalOnNavigateWithUnsavedChangesBehavior = BaseUnsavedChangesBehavior.extend({
    modelEvents: {
      destroy: 'stopListeningToBackboneHistory',
    },

    onFirstRender: function() {
      BaseUnsavedChangesBehavior.prototype.onFirstRender.apply(this, arguments);

      //prettier-ignore
      var currentFragment = Backbone.history.fragment,
          resource        = this.getResource();

      this.listenTo(
        Backbone.history,
        'before:route',
        function(router, name, ev, params) {
          if (this.unsavedChangesExist()) {
            ev.preventDefault = true;

            Backbone.history.navigate(currentFragment, { replace: true });

            this.createUnsavedChangesModal()
              .on(
                'confirm',
                function() {
                  this.saveResource(resource)
                    .bind(this)
                    .tap(function(resp) {
                      this.stopListeningToBackboneHistory();
                      this.navigateUser(ev.fragment);
                    });
                },
                this
              )
              .on(
                'deny',
                function() {
                  this.stopListeningToBackboneHistory();
                  this.navigateUser(ev.fragment);
                },
                this
              );
          }
        },
        this
      );
    },

    saveResource: function(resource) {
      if (resource instanceof Backbone.Model) {
        return Promise.resolve(resource.save());
      } else {
        return this.saveCollection(resource);
      }
    },

    saveCollection: function(collection) {
      var requests = [];
      if (_.isFunction(collection.save)) {
        return Promise.resolve(collection.save());
      } else {
        collection.each(function(model) {
          // making sure to only save models that actually have changes
          if (model.hasChanged()) {
            requests.push(Promise.resolve(model.save()));
          }
        });
      }
      return Promise.all(requests);
    },

    createUnsavedChangesModal: function(options) {
      if (this.view.buildComponent) {
        return this.view.buildComponent(_.extend({ type: UnsavedChangesModalView, visible: true }, options));
      }
      throw new Error('The ConfirmModelDestroyOnPressBehavior was attached to a non-uikit view');
    },

    stopListeningToBackboneHistory: function() {
      this.stopListening(Backbone.history);
    },

    navigateUser: function(fragment) {
      Backbone.history.navigate(fragment, { trigger: true });
    },
  });

  module.exports = ShowModalOnNavigateWithUnsavedChangesBehavior;
});

